import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import GroupForm from "../Layouts/GroupForm";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
import { GroupFormValues } from "src/models/Group.model";
import {
  useGetGroupByIdQuery,
  useUpdateGroupByIdMutation,
} from "src/services/GroupService";

type Props = {
  onClose: () => void;
  selectedGroupId: string;
};

const EditGroupWrapper = ({ onClose, selectedGroupId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } =
    useGetGroupByIdQuery(selectedGroupId);
  const [updateGroupById] = useUpdateGroupByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);
  const initialValues: GroupFormValues = {
    groupName: items?.groupName || "",
    order: items?.order || "",
  };
  // Validation Schema
  const validationSchema = object().shape({
    groupName: string().required("Please enter Group name"),
    order: string().required("Please enter order"),
  });

  // Handle Submit
  const handleSubmit = (
    values: GroupFormValues,
    { setSubmitting, resetForm }: FormikHelpers<GroupFormValues>
  ) => {
    const payload = {
      groupName: values.groupName,
      order: Number(values.order),
    };
    updateGroupById({ id: selectedGroupId, body: payload }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <GroupForm
              formikProps={formikProps}
              onClose={onClose}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditGroupWrapper;
